const LOCATIONS = "LOCATIONS";
const ADD_LOCATION = "ADD_LOCATION";

export { LOCATIONS, ADD_LOCATION };
